<template>
    <admin-breadcrumbs>
        <li class="breadcrumb-item">
            <router-link to="/admin/series/">
                Series
            </router-link>
        </li>

        <li class="breadcrumb-item">
            <router-link :to="`/admin/components/${$route.query.component_id}/`">
                Components
            </router-link>
        </li>

        <li class="breadcrumb-item active">
            Create Translation
        </li>
    </admin-breadcrumbs>

    <div class="card card-default">

        <div class="card-header">
            Create Translation
        </div>

        <div class="card-body">
            <div
                v-if="component.id"
                class="row"
            >

                <div class="col-md-6">

                    <h4>
                        Original
                    </h4>

                    <div class="form-group">
                        <label>Type</label>
                        <input
                            type="text"
                            disabled
                            :value="component.type.name"
                            class="form-control"
                        />
                    </div>

                    <div class="form-group">
                        <label>
                            Language
                        </label>
                        <input
                            type="text"
                            disabled
                            value="English"
                            class="form-control"
                        />
                    </div>

                    <component-view-form
                        :endpoint="`/admin/api/components/${$route.query.component_id}`"
                        method="put"
                    />

                </div>

                <div class="col-md-6">

                    <translation-create-form
                        endpoint="/admin/api/translations"
                        method="post"
                        :data="{'component_id': component.id}"
                        :component-id="component.id"
                        :component-type="component.type.name"
                    />

                </div>

            </div>
        </div>

    </div>
</template>

<script>
import ComponentViewForm from "../../../admin/ComponentViewForm.vue";
import TranslationCreateForm from "../../../admin/TranslationCreateForm.vue";
import AdminBreadcrumbs from "../../../partials/AdminBreadcrumbs.vue";

export default {
    name: "TranslationCreate",

    components: {
        AdminBreadcrumbs,
        TranslationCreateForm,
        ComponentViewForm,
    },

    data() {
        return {
            component: {},
        }
    },

    mounted() {
        axios.get(`/admin/api/components/${this.$route.query.component_id}`)
            .then((response) => {
                this.component = response.data;
            });
    },
};
</script>
